import { FC, Fragment, useState } from "react";
// i18next
import { useTranslation } from "react-i18next";
// Redux
import { useAppSelector } from "app/hooks/useStore";
// Models
import { RootState } from "app/store";
// Selectors
import { selectDocumentsAsOptions } from "app/store/DMSDocuments/DMSDocuments.selectors";
// Components
import Dialog from "app/components/Dialog";
import { Button } from "app/components/Mui";
import { DocumentPopupDropdown } from "app/components/DocumentPopupDropdown";

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (documentIds: any) => void;
};

const WorkflowDialog: FC<Props> = ({ open, onClose, onSubmit }) => {
  const { t } = useTranslation();

  const documentOptions = useAppSelector((state: RootState) =>
    selectDocumentsAsOptions(state, {
      excludeCustomFormat: false,
      onlyOcred: true,
    })
  );

  const [selectedDocumentIds, setSelectedDocumentIds] = useState<number[]>([]);

  const isDisabled = selectedDocumentIds.length === 0;

  const actions = (
    <Fragment>
      <Button name="Close workflow dialog" onClick={onClose}>
        {t("buttons.close")}
      </Button>
      <Button
        name="Run workflow"
        variant="contained"
        color="primary"
        disabled={isDisabled}
        onClick={onSubmit(selectedDocumentIds)}
      >
        {t("buttons.run")}
      </Button>
    </Fragment>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            position: 'absolute',
            top: '4%'
          }
        }
      }}
      title={t("dialogs.workflow.title")}
      actions={actions}
      maxWidth="sm"
    >
      <DocumentPopupDropdown
        value={selectedDocumentIds}
        onChange={setSelectedDocumentIds}
        placeholder="Select documents ..."
        options={documentOptions as any[]}
      />
    </Dialog>
  );
};

export default WorkflowDialog;
